import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const footerStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: '64px',
		color: 'white',
		background: '#000000',
		pt: '110px',
		pb: '40px',
		px: '20px',
	},
	logo: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
	},
	links: {
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'center',
		gap: '93px',
		textTransform: 'uppercase',
	},
	linksColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
	},
	linksColumnTitle: {
		fontFamily: 'Integral CF',
		fontSize: '16px',
		fontWeight: '400',
	},
	linksColumnContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	linkItem: {
		fontFamily: 'Integral CF',
		fontSize: '14px',
		fontWeight: '500',
		fontStyle: 'italic',
		cursor: 'pointer',
		color: 'inherit',
		textDecoration: 'none',

		'&:hover': {
			textDecoration: 'underline',
			textDecorationColor: Colors['FF6000'],
			textDecorationThickness: '2px',
			textUnderlineOffset: '4px',
		},
	},
	copyright: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		fontFamily: 'Integral CF',
	},
	copyrightContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '12px',
	},
	copyrightText: {
		fontFamily: 'Integral CF',
		fontSize: '14px',
		fontWeight: '400',
	},
	copyrightCode: {
		fontFamily: 'Integral CF',
		fontSize: '12px',
		fontWeight: '400',
		opacity: '0.4',
	},
	appStoreButtons: {
		mb: 3,
	},
});
